import { useEffect } from 'react';
import { useDispatch } from '../../data-layer/useDispatch';
import { useSelector } from '../../data-layer/useSelector';
import { loadUserByIdAsync } from '../../data-layer/user/actions';
import { CURRENT_USER_ID } from '../../data-layer/user/constants';
import { selectUserById, selectUserDetailsLoading } from '../../data-layer/user/selectors';
import { getCookie } from '../../utils/getCookie';
import type { UserModel } from '../../data-layer/user/types';

export const useCurrentUser = (): UserModel | undefined => {
    const dispatch = useDispatch();
    const yandexLogin = typeof window === 'undefined' ? undefined : getCookie('yandex_login');
    const currentUser = useSelector((state) => selectUserById(state, CURRENT_USER_ID));

    useEffect(() => {
        if (yandexLogin && !currentUser) {
            dispatch(loadUserByIdAsync(CURRENT_USER_ID));
        }
    }, [currentUser, yandexLogin, dispatch]);

    return currentUser;
};

export const useCurrentUserIsLoading = () => {
    const isLoading = useSelector((state) => selectUserDetailsLoading(state, CURRENT_USER_ID));

    return isLoading;
};
